module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Victorian Wardrobes (9).4458691f.jpg";